import React from 'react';

const Snacks = () => {
  return <div>Snacks Dashboard</div>
}

export default Snacks;
